<script setup>
import { computed } from "vue";
import { StealieButton } from "@get-overalls/fe-stealie";
import MessageRow from "@/components/billybot/MessageRow.vue";

const props = defineProps({
  questions: {
    type: Array,
    required: true,
  },
  category: {
    type: String,
    required: true,
  },
  submitting: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["response:edit", "submit-request"]);

const handleEditResponse = (response) => {
  const question = props.questions.find((q) => q.id === response.questionId);
  if (!question) {
    console.error("Question not found", response);
    return;
  }

  emit("response:edit", response);
};

const editing = computed(() => {
  return props.questions.some((question) => question.editing);
});

const handleSubmitRequest = () => {
  emit("submit-request");
};
</script>

<template>
  <div class="flex h-full flex-col">
    <header
      class="sticky top-0 flex gap-x-8 gap-y-2 bg-brand-primary-teal-50 p-8 pb-0 sm:flex-row sm:pb-0"
    >
      <div
        class="h-24 w-30 overflow-hidden object-cover object-top sm:block sm:h-36 sm:w-44"
      >
        <img src="/illustrations/billy-bot-full.svg" />
      </div>
      <div class="flex flex-col gap-y-4">
        <!-- TODO: add an xs breakpoint -->
        <StealieHeading
          level="2"
          size="lg"
          class="!text-[1.375rem] text-balance sm:!text-h2"
        >
          OK, Partner!
          <span class="block sm:inline"> A quick review before you submit.</span>
        </StealieHeading>
      </div>
    </header>
    <div class="scrollbox p-4 pb-2 sm:p-6 sm:pb-4">
      <div
        class="flex flex-1 flex-col gap-y-5 divide-y divide-brand-gray-50 rounded-lg border border-brand-gray-50 bg-brand-primary-teal-highlight/60 p-4"
      >
        <MessageRow
          v-for="question in questions"
          :key="question.id"
          :category="category"
          :question="question"
          summary
          @response:edit="handleEditResponse"
        />
      </div>
    </div>
    <footer class="px-4">
      <StealieButton
        variant="primary"
        full-width
        :disabled="editing"
        :loading="submitting"
        @click="handleSubmitRequest"
      >
        {{
          editing
            ? "Finish editing above"
            : submitting
              ? "Submitting"
              : "Submit my request"
        }}
      </StealieButton>
    </footer>
  </div>
</template>
